module.exports = __webpack_public_path__ + "img/2025-05-09a_4.20293b6c.jpg";